import { ISimplePromotionConfiguration } from '@barkinglabs/promotions-types';

/**
 * Resolves the coupon code from a promotion configuration using localized text
 * entries. Mirrors promotions-react's internal resolveLocalizedText so the code
 * we apply matches the code the banner displays.
 *
 * Fallback order:
 *   1. Exact match on (language, country)
 *   2. Default entry for the same country
 *   3. Any entry for the same country
 *   4. Top-level couponCode (legacy)
 */
export function resolvePromotionCouponCode(
  config: ISimplePromotionConfiguration,
  language?: string,
  country?: string,
): string | undefined {
  const entries = config.localizedText;
  if (!entries || entries.length === 0) {
    return config.couponCode;
  }

  if (language && country) {
    const exact = entries.find((e) => e.language === language && e.country === country);
    if (exact) return exact.couponCode;
  }

  if (country) {
    const countryDefault = entries.find(
      (e) => e.country.toUpperCase() === country.toUpperCase() && e.defaultForCountry,
    );
    if (countryDefault) return countryDefault.couponCode;

    const anyCountry = entries.find((e) => e.country.toUpperCase() === country.toUpperCase());
    if (anyCountry) return anyCountry.couponCode;
  }

  return config.couponCode;
}
